import React, {ReactElement} from 'react';
import {FeedbackModal, FeedbackModalContentFC} from "../Generic/FeedbackModal";
import {useQuerySearchParams} from "../../../../config/queryClient";
import {StudentExerciseAttempt} from "../../../../types";
import {SpinContainer} from "../../../SpinContainer";
import {Divider, List, Typography} from "antd";
import {GUTTER} from "../../../../constants";

const {Text} = Typography;

interface Order {
    id: string,
    investigations: Investigation[]
}

interface Investigation {
    id: string,
    cost: string,
    name: string,
    result: string,
    time_estimated: string
}
export const Orders: FeedbackModalContentFC = ({attemptId}) => {
    
    const {data, isLoading} = useQuerySearchParams<StudentExerciseAttempt>(`/reports/student-exercise-attempts/${attemptId}/`, [], {
        defaultFilters: {
            fields: 'id,feedback'
        }
    })
    if (isLoading) return <SpinContainer/>;

    return (
       data?.feedback?.user_orders.orders.map((order:Order, index: number) =>
                <div key={order.id} style={{paddingLeft: GUTTER[0], paddingRight: GUTTER[0]}}>
                    <Divider orientation="left">Order {index + 1}</Divider>
                    <List dataSource={order.investigations} renderItem={item => (
                        <List.Item>
                            <Text>{item.name}</Text>
                            <Text>{item.cost}</Text>
                            <Text>{item.time_estimated}</Text>
                        </List.Item>
                    )}/>
                </div>
            ) 
    )
}

Orders.title = 'Orders';